module.exports = __webpack_public_path__ + "img/tooltip_04-VALLONE_MURALE_ROUND_DOPPIO_C01149_C.bac97aaa.jpg";